import React, { useEffect, useState } from 'react';
import MuiTable from '../../../components/MuiTable/MuiTable';
import Button from '../../../components/Button/Button';
import {
  updateDownloadID,
  updateFlashBar,
  updateIsLoading,
} from '../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import instance from '../../../service/axiosInstane';
import { flashBarTheme } from '../../../config/flashBar';
import qs from 'qs';
import { Column } from '../../../components/MuiTable/ViewData';
import Filter from '../../../components/Filter/Filter';
import { Role, SortOrderType } from '../../../config/enum';
import { totalPages } from '../../../config/helpers';
import { errorMessage } from '../../../config/errorsMsg';
import { IndexProps } from '../WebsiteDetailsAdmin';
import { StateProps } from '../../../redux/reducer';
import Dailog from '../../../components/Dailog/Dailog';
import { successMessage } from '../../../config/keyword';

type RootProps = {
  name: string;
  value: boolean | string | null;
};

type RequestProps = {
  DmcaGenerated: boolean | null;
  SiteOrganizationIndexId: string;
  siteOrganizationId: string | undefined | null;
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string;
};

type ResultProps = {
  id: string;
  weblinkUrl: string;
  keywordText: string;
  generatedDmca: boolean;
};

type SiteIndexProps = {
  name: string;
  value: string | boolean | null;
};

type ResponseProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results: ResultProps[];
};

type WebsiteDMCAProps = {
  siteOrganizationId: string | undefined | null;
  siteOrganizationIndexName: string;
  siteOrganizationIndexId: string;
  allsiteOrganizationIndexId: IndexProps[];
};

const columns: Column[] = [
  {
    id: 'weblinkUrl',
    label: 'Weblinks',
    minWidth: 500,
    align: 'left',
  },
  {
    id: 'categoryName',
    label: 'Category Name',
    minWidth: 200,
    align: 'left',
  },
  {
    id: 'categoryLable',
    label: 'Category Label',
    minWidth: 200,
    align: 'left',
  },
  {
    id: 'keywordText',
    label: 'Keyword',
    minWidth: 200,
    align: 'center',
  },

  {
    id: 'isDmcaGenerated',
    label: 'Generated DMCA',
    minWidth: 200,
    align: 'center',
  },
  {
    id: 'markForArchive',
    label: 'Archive',
    minWidth: 120,
    align: 'center',
  },
];

const rootFilter: RootProps[] = [
  {
    name: 'All',
    value: null,
  },
  {
    name: 'DMCA Notified',
    value: true,
  },
  {
    name: 'DMCA Not Notified',
    value: false,
  },
];

const WebsiteDMCA = (props: WebsiteDMCAProps) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [requestWeblink, setRequestWeblink] = useState<RequestProps>({
    DmcaGenerated: false,
    siteOrganizationId: props.siteOrganizationId,
    SiteOrganizationIndexId: props.siteOrganizationIndexId,
    Page: 1,
    PageSize: 20,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [weblinks, setWebLinks] = useState<ResultProps[]>([]);
  const [siteIndex, setSiteIndex] = useState<SiteIndexProps[]>([
    { name: '', value: '' },
  ]);
  const [isDeletePopup, setIsDeletePopup] = useState<boolean>(false);
  const [fliterValue, setFilterValue] = useState('"All"');

  const filterColumns =
    userInfo.role === Role.User
      ? columns.filter((item) => item.id !== 'markForArchive')
      : columns;
  const [siteIndexLabel, setSiteIndexLable] = useState(
    props.siteOrganizationIndexName === undefined
      ? 'Select Index'
      : props.siteOrganizationIndexName + ' (Active) '
  );
  useEffect(() => {
    getWebLinks(requestWeblink);
    setSiteIndex(
      props.allsiteOrganizationIndexId.map((item: IndexProps) => {
        if (item.isActive) {
          return {
            name: item.name + ' (Active) ',
            value: item.id,
          };
        } else {
          return {
            name: item.name,
            value: item.id,
          };
        }
      })
    );
    if (requestWeblink.DmcaGenerated === false) {
      setFilterValue('"DMCA Not Notified"');
    } else if (requestWeblink.DmcaGenerated === true) {
      setFilterValue('"DMCA Notified"');
    } else if (requestWeblink.DmcaGenerated === null) {
      setFilterValue('"All"');
    } else {
      setFilterValue('"All"');
    }
  }, []);

  const getWebLinks = (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/weblinks?${queryString}`;
    instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResponseProps) => {
    setTotalRowCount(data.totalCount);
    if (data.results !== null) {
      setWebLinks(data.results as ResultProps[]);
    } else {
      setWebLinks([]);
    }
    dispatch(updateIsLoading(false));
  };

  const filterHandler = (row: RootProps) => {
    getWebLinks({
      ...requestWeblink,
      DmcaGenerated: row.value as boolean,
      Page: page,
      PageSize: limit,
    });

    setRequestWeblink({ ...requestWeblink, DmcaGenerated: row.value as boolean });
    if (row.value === false) {
      setFilterValue('"DMCA Not Notified"');
    } else if (row.value === true) {
      setFilterValue('"DMCA Notified"');
    } else if (row.value === null) {
      setFilterValue('"All"');
    } else {
      setFilterValue('"All"');
    }
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getWebLinks({ ...requestWeblink, Page: page, PageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...requestWeblink,
          Page: page + 1,
          PageSize: limit,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getWebLinks({
          ...requestWeblink,
          Page: page - 1,
          PageSize: limit,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getWebLinks({
          ...requestWeblink,
          Page: 1,
          PageSize: limit,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...requestWeblink,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getWebLinks({
        ...requestWeblink,
        Page: 1,
        PageSize: item,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const weblinksAchived = async (row: ResultProps) => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`weblinks/${row.id}/archive`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ARCHIVE_SUCCESS,
            type: flashBarTheme.SUCCESS,
          };
          getWebLinks({
            ...requestWeblink,
            Page: 1,
            PageSize: limit,
            DmcaGenerated: requestWeblink.DmcaGenerated,
          });
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const generatedDMCA = async () => {
    const obj = {
      dmcaGenerated: requestWeblink.DmcaGenerated,
      siteOrganizationId: props.siteOrganizationId,
    };
    dispatch(updateIsLoading(true));
    await instance
      .post(`/weblinks/generate-dmca`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.DMCA_GENERATE,
            type: flashBarTheme.SUCCESS,
          };
          const download = {
            isShow: true,
            downloadGuid: response.data.documentStoreId,
          };
          dispatch(updateDownloadID(download));
          getWebLinks({
            ...requestWeblink,
            Page: page,
            PageSize: limit,
            DmcaGenerated: requestWeblink.DmcaGenerated,
          });
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const filterIndexHandler = (row: SiteIndexProps) => {
    getWebLinks({
      ...requestWeblink,
      Page: page,
      PageSize: limit,
      SiteOrganizationIndexId: row?.value as string,
    });
    setRequestWeblink({
      ...requestWeblink,
      SiteOrganizationIndexId: row.value as string,
    });
    setSiteIndexLable(row.name);
  };

  const generateDMCA = () => {
    setIsDeletePopup(true);
  };

  const onSubmit = () => {
    generatedDMCA();
    setIsDeletePopup(false);
  };

  const sortRecord = (fieldName: string, SortOrder: string) => {
    getWebLinks({
      ...requestWeblink,
      SortOrder: sorting(SortOrder),
      SortBy: fieldName,
      Page: page,
      PageSize: limit,
      SearchText: requestWeblink.SearchText,
    });
    getWebLinks({
      ...requestWeblink,
      SortBy: fieldName,
      SortOrder: sorting(SortOrder),
    });
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestWeblink({ ...requestWeblink, SortOrder: temp });
    return temp;
  };

  return (
    <div className="bg-white">
      <div className="sm:flex items-center justify-between p-2">
        <div className="font-semibold text-lg">DMCA Management</div>
        {weblinks.length > 0 && (
          <Button
            label={'Generate DMCA'}
            type={'button'}
            buttonType={'primary'}
            onClick={() => generateDMCA()}
          />
        )}
      </div>
      <div className="lg:flex items-center justify-between px-1 mb-2">
        <div className="mb-3 lg:mb-0">
          <Filter
            filterHandler={filterHandler}
            rootFilter={rootFilter}
            label={fliterValue}
            heading={'Please select'}
          />
        </div>
        <div>
          {' '}
          <Filter
            filterHandler={filterIndexHandler}
            rootFilter={siteIndex}
            label={siteIndexLabel}
            heading="Select Index"
          />
        </div>
      </div>

      <MuiTable
        columns={filterColumns}
        rows={weblinks}
        checkBoxShow={false}
        checkBoxValue={'id'}
        page={page}
        limit={limit}
        paginateHandler={paginateHandler}
        totalRowCount={totalRowCount}
        onMarkForArchived={weblinksAchived}
        onSortHandler={sortRecord}
        sortOrder={requestWeblink.SortOrder}
        sortArray={['weblinkUrl']}
      />
      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'DMCgfdgdfA'}
          onConfirm={onSubmit}
          type={'generate'}
          fliterVal={fliterValue}
        />
      </div>
    </div>
  );
};

export default WebsiteDMCA;
